(function () {
  var me = document.currentScript;
  var lib = me && me.getAttribute('data-lib');
  if (!lib || typeof window.gtag !== 'function') return;

  function send(m) {
    if (typeof window.gtag !== 'function') return;
    window.gtag('event', 'web_vitals', {
      metric_name: m.name,
      metric_value: Math.round(m.name === 'CLS' ? m.value * 1000 : m.value),
      metric_rating: m.rating,
      metric_id: m.id
    });
  }

  function load() {
    var s = document.createElement('script');
    s.src = lib;
    s.async = true;
    s.onload = function () {
      var wv = window.webVitals;
      if (!wv) return;
      wv.onLCP(send); wv.onCLS(send); wv.onINP(send); wv.onTTFB(send); wv.onFCP(send);
    };
    document.head.appendChild(s);
  }
  function soon() {
    if ('requestIdleCallback' in window) requestIdleCallback(load, { timeout: 2000 });
    else setTimeout(load, 500);
  }
  if (document.readyState === 'complete') soon();
  else window.addEventListener('load', soon, { once: true });
})();
